(function($) {
  'use strict';

  // Hides / Shows Placeholder Text on Input Fields
  // Does have to be called from onkeyup event
  $.fn.setPlaceholder = function() {
    var el = $(this);
    var ph = el.parent().children('.placeholder');
    var input = el.val();

    if(input !== '') {
      $(ph).addClass('hidden');
    } else {
      $(ph).removeClass('hidden');
    }
  };

  var menuOverviewSet = 0;

  // add toggle functionality to submenus
  function maybeAddMobileMenuFunctionality() {

    // or maybe not
    if( $(window).width() > 1199 ) return;

    var menu         = $('#MainMenu')
      , submenuLinks = menu.find('.menu-item-has-children > a')
      , overviewText = menu.parent().data('overview-text');

    submenuLinks.each( function() {

      if(menuOverviewSet < submenuLinks.length) {

        // add menu overview entry
        var submenu = $(this).parent().children('.sub-menu')
          , url = $(this).attr('href')
          , item = document.createElement('li')
          , link = document.createElement('a');

        item.className = 'menu-item overview-item';
        link.setAttribute('href', url);
        link.innerHTML = overviewText;
        $(item).append(link);

        submenu.prepend(item);

        menuOverviewSet++;

      }

      // add onclick
      $(this).click( function( event ) {
        event.preventDefault();

        // toggle parent so icon and submenu visibility get changed
        $(this).parent().toggleClass('toggled');
      } );
    } );


  }

  // call at document ready
  $(maybeAddMobileMenuFunctionality);

  // call at resize event
  $(window).on('resize', debounce(maybeAddMobileMenuFunctionality, 250, true) );

})(jQuery);
